import {
    Avatar,
    AvatarFallbackText,
    AvatarImage,
    HStack,
    UserContext,
    VStack
} from "@hosttools/frontend";
import gravatar from "gravatar";
import upperFirst from "lodash/upperFirst";
import type React from "react";
import {memo, useContext, useMemo} from "react";

import Paragraph from "../Paragraph";
import Text from "../Text";

type Props = {
    showName?: boolean;
};

const AvatarProfile: React.FC<Props> = ({showName}) => {
    const {
        user: {fullName, username, subscriptionStatus}
    } = useContext(UserContext);

    const userImageUri = useMemo(
        () => ({uri: gravatar.url(username, {s: "120", r: "pg", d: "mp"})}),
        [username]
    );

    const displayName = fullName.trim() || username;

    return (
        <HStack className="items-center" space="sm">
            <Avatar className="bg-cyan-600" size="sm">
                <AvatarImage source={userImageUri} />
                <AvatarFallbackText>{displayName}</AvatarFallbackText>
            </Avatar>
            {showName && (
                <VStack>
                    <Text color="blueGray.800" testID="profile-name" variant="sm">
                        {displayName}
                    </Text>
                    {subscriptionStatus && (
                        <Paragraph color="blueGray.400" variant="xs">
                            {upperFirst(subscriptionStatus)}
                        </Paragraph>
                    )}
                </VStack>
            )}
        </HStack>
    );
};

export default memo(AvatarProfile);
